module.exports = __webpack_public_path__ + "static/media/tl_banner.821a6bb3.png";